module.exports = __webpack_public_path__ + "media/credit.d04d4c02.mp3";